import React, { useEffect, useState } from 'react';
import { object, string } from 'yup';
import Modal from 'react-modal';

import { Form, Input, Button } from '../../components/_shared';
import MESSAGES from '../../locales';

const PasswordChangeSchema = object().shape({
  password: string()
    .required(MESSAGES['password.presence'])
    .min(6, MESSAGES['password.minLength']),

  confirmPassword: string().required('Confirm password is required.'),
});

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '500px',
  },
};

const ChangePasswordModal = ({ open, error: err, onSubmit, onClose }) => {
  const [show, setShow] = useState(false);
  const [error, setError] = useState(err);

  useEffect(() => setShow(open), [open]);
  useEffect(() => {
    setError(err);

    const to = setTimeout(() => setError(''), 3000);

    return () => to && clearTimeout(to);
  }, [err]);

  return (
    <Modal isOpen={show} style={customStyles} onRequestClose={onClose}>
      <Form schema={PasswordChangeSchema} onSubmit={onSubmit}>
        <h3 className="mb-6 text-2xl text-center">Change Password</h3>

        <div className="mb-3">
          <Input
            id="password"
            name="password"
            label="New Password"
            type="password"
            autoComplete="off"
            required
          />
        </div>
        <div className="mb-3">
          <Input
            id="confirmPassword"
            name="confirmPassword"
            label="Confirm Password"
            type="password"
            autoComplete="off"
            required
          />
        </div>
        {error && <div className="error">{error}</div>}
        <div className="flex mt-6">
          <Button
            className="p-3 w-1/2 rounded-lg"
            type="secondary"
            caption="Change"
          />
          <Button
            className="ml-3 w-1/2 rounded-lg"
            type="primary"
            caption="Cancel"
            onClick={onClose}
          />
        </div>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
